import { useState } from "react";
import axios from "axios";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Contact() {
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const whatsappNumber = "918295080493";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent("Hello! I would like to get in touch.")}`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await axios.post(`${API}/contact`, formData);
      toast.success("Message sent successfully! We will get back to you soon.");
      setFormData({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      console.error("Error submitting contact form:", error);
      toast.error("Failed to send message. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1
            className="text-5xl md:text-6xl font-heading font-bold text-[#2D3436] mb-4"
            data-testid="contact-page-title"
          >
            Get in <span className="text-primary">Touch</span>
          </h1>
          <p className="text-lg text-[#636E72] max-w-3xl mx-auto">
            Have questions? We're here to help you on your wellness journey
          </p>
        </div>

        <div className="flex justify-center">
          <div>
            <h2 className="text-2xl font-heading font-semibold text-[#2D3436] mb-6">
              Contact Information
            </h2>

            <div className="space-y-6 mb-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Phone className="text-primary" size={20} />
                </div>
                <div>
                  <h3 className="font-semibold text-[#2D3436] mb-1">Phone</h3>
                  <p className="text-[#636E72]">
                    +91 8199937841, +91 82950 80493
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Mail className="text-primary" size={20} />
                </div>
                <div>
                  <h3 className="font-semibold text-[#2D3436] mb-1">Email</h3>
                  <p className="text-[#636E72]">tricityayurveda@gmail.com</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <MapPin className="text-primary" size={20} />
                </div>
                <div>
                  <h3 className="font-semibold text-[#2D3436] mb-1">
                    Location
                  </h3>
                  <p className="text-[#636E72]">Tricity Area, Chandigarh</p>
                </div>
              </div>
            </div>

            <div className="bg-accent/30 p-6 rounded-xl">
              <h3 className="font-semibold text-[#2D3436] mb-3">
                Consultation Hours
              </h3>
              <p className="text-[#636E72] mb-4">
                Flexible consultation timing. Contact us via WhatsApp to
                schedule your appointment.
              </p>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                <Button
                  className="bg-[#25D366] hover:bg-[#20B558] text-white rounded-full w-full"
                  data-testid="contact-whatsapp-button"
                >
                  <MessageCircle size={18} className="mr-2" />
                  Chat on WhatsApp
                </Button>
              </a>
            </div>
          </div>
          {/* 
          <div className="bg-white p-8 rounded-2xl border border-border/50 shadow-sm">
            <h2 className="text-2xl font-heading font-semibold text-[#2D3436] mb-6">
              Send Us a Message
            </h2>

            <form
              onSubmit={handleSubmit}
              className="space-y-6"
              data-testid="contact-form"
            >
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-[#2D3436] mb-2"
                >
                  Your Name *
                </label>
                <Input
                  id="name"
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  required
                  className="bg-white border-border focus:border-primary focus:ring-primary/20 rounded-lg"
                  data-testid="contact-name-input"
                />
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-[#2D3436] mb-2"
                >
                  Email Address *
                </label>
                <Input
                  id="email"
                  type="email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  required
                  className="bg-white border-border focus:border-primary focus:ring-primary/20 rounded-lg"
                  data-testid="contact-email-input"
                />
              </div>

              <div>
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium text-[#2D3436] mb-2"
                >
                  Phone Number *
                </label>
                <Input
                  id="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={(e) =>
                    setFormData({ ...formData, phone: e.target.value })
                  }
                  required
                  className="bg-white border-border focus:border-primary focus:ring-primary/20 rounded-lg"
                  data-testid="contact-phone-input"
                />
              </div>

              <div>
                <label
                  htmlFor="message"
                  className="block text-sm font-medium text-[#2D3436] mb-2"
                >
                  Your Message *
                </label>
                <Textarea
                  id="message"
                  value={formData.message}
                  onChange={(e) =>
                    setFormData({ ...formData, message: e.target.value })
                  }
                  required
                  rows={5}
                  className="bg-white border-border focus:border-primary focus:ring-primary/20 rounded-lg"
                  placeholder="Tell us how we can help you..."
                  data-testid="contact-message-textarea"
                />
              </div>

              <Button
                type="submit"
                disabled={submitting}
                className="w-full bg-primary hover:bg-[#3A5233] text-white rounded-full py-3"
                data-testid="submit-contact-button"
              >
                {submitting ? "Sending..." : "Send Message"}
              </Button>
            </form>
          </div> */}
        </div>
      </div>
    </div>
  );
}
